export const PROOF_OF_IDENTITY = 'PROOFOFIDENTITY'

export const HARD_POS_AGGREGATOR = 'HARDPOS_AGGREGATOR'

export const INDIA = 'India'
